import type { useForm } from "hooks";
import type { BootstrapableForm, Option } from "types";
import type { BankingSdkRecipient } from "features/openBanking/types";

export const enum FormField {
    EndToEndIdSlug = 'endToEndIdSlug',
    Name = 'name',
    AddressType = 'addressType',
    Department = 'department',
    SubDepartment = 'subDepartment',
    StreetName = 'streetName',
    BuildingNumber = 'buildingNumber',
    PostCode = 'postCode',
    TownName = 'townName',
    Country = 'country',
    CountrySubdivision = 'countrySubdivision',
    IbanAccount = 'ibanAccount',
    BbanAccount = 'bbanAccount',
    AgentBicFi = 'agentBicFi',
    ClearingMemberId = 'clearingMemberId',
    AccountCurrency = 'accountCurrency'
};

export type BankingSDKRecipient = {
    readonly [FormField.AddressType]: Option | null;
    readonly [FormField.Country]: Array<string>;
} & Pick<
    BankingSdkRecipient,
    | 'endToEndIdSlug'
    | 'name'
    | 'department'
    | 'subDepartment'
    | 'streetName'
    | 'buildingNumber'
    | 'postCode'
    | 'townName'
    | 'countrySubdivision'
    | 'ibanAccount'
    | 'bbanAccount'
    | 'agentBicFi'
    | 'clearingMemberId'
    | 'accountCurrency'
>;

export type BootstrapData = {
    readonly addressType: Array<Option>;
    readonly BankingSdkRecipientEndToEndSlug: Array<string>;
};

export type BankingSDKRecipientForm = Omit<
    BootstrapableForm<
        BankingSDKRecipient,
        BootstrapData
    >,
    | 'initialValues'
> & {
    readonly initialValues: BankingSDKRecipient;
};

export type BankingSDKRecipientProps =
    & BankingSDKRecipientForm
    & ReturnType<typeof useForm<BankingSDKRecipient>>;
